$(document).ready(function () {
	$('.weight-select').on('change', function () {
		let $product = $(this).closest('[data-cart="product"]');
		let $selected = $(this).find('option:selected');
		let price = $selected.data('price');
		let price_old = $selected.data('price_original');

		$product.find('.price:visible .current').text(output_roubles(price));
		$product.find('.price:visible del').text(output_roubles(price_old));
		return false
	});
});